import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingNav.css';

const LandingNav = () => {
    const navigate = useNavigate();
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 20);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
            setIsMobileMenuOpen(false);
        }
    };

    return (
        <nav className={`landing-nav ${isScrolled ? 'scrolled' : ''}`}>
            <div className="nav-container">
                <div className="nav-brand" onClick={() => navigate('/')}>
                    <span className="brand-text">BioSite</span>
                    <span className="brand-dot">.</span>
                </div>

                <ul className={`nav-links ${isMobileMenuOpen ? 'open' : ''}`}>
                    <li>
                        <button className="nav-link" onClick={() => navigate('/')}>
                            Ana Sayfa
                        </button>
                    </li>
                    <li>
                        <button className="nav-link" onClick={() => scrollToSection('features')}>
                            Özellikler
                        </button>
                    </li>
                    <li>
                        <button 
                            className="nav-link login-btn"
                            onClick={() => navigate('/dashboard')}
                        >
                            Giriş Yap
                        </button>
                    </li>
                </ul>

                <button 
                    className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
                    onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    aria-label="Menu"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </div>
        </nav>
    );
};

export default LandingNav;

